'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('@emotion/react');
var InternalRadio_web = require('../../internal/InternalRadio/InternalRadio.web.cjs');
require('../../internal/InternalSkeleton/InternalSkeleton.web.styles.cjs');
require('../Typography/Typography.web.cjs');
require('aviary-tokens');
require('@remix-run/react');
require('react-router-dom');

/**
 * A radio component for selecting a single option from a list.
 *
 * @scope Core
 */ const Radio = ({ children, customCss, ...internalProps })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(InternalRadio_web.InternalRadio, {
        ...internalProps,
        css: customCss,
        children: children
    });
};

exports.Radio = Radio;
//# sourceMappingURL=Radio.web.cjs.map
